import { useEffect } from "react";
import Header from "./Header";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalModal } from "../../components/authModals";
import MainHeader from "./MainHeader";
import Footer from "./Footer";
import getUser from "../../api/user";
import { setUser } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/slices/uiSlice";
import { setEmailVerification } from "../../redux/slices/authSlice";
import type { RootState } from "../../redux/store";
import { useQuery } from "@tanstack/react-query";
import NewAchievementNotification from "../../components/notification/NewAchievementNotification";

const Main = () => {
  const storedLang = localStorage.getItem("i18nextLng") || "en";
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);
  const modalType = useSelector((state: RootState) => state.ui.modal.modalType);
  useEffect(() => {
    // Read token inside useEffect to get the latest value
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!token || token === "undefined" || token === "null" || token.trim() === "") {
      navigate("/");
    }
  }, [navigate]);

  const { data: userData } = useQuery({
    queryKey: ["user"],
    queryFn: () => getUser(),
  });

  useEffect(() => {
    if (userData) {
      dispatch(setUser(userData as any));
    }
  }, [userData, dispatch]);

  // Check email verification status when user changes
  useEffect(() => {
    if (user?.email && user?.is_email_verified === false && modalType !== "verifyEmail") {
      dispatch(setEmailVerification(user.email));
      dispatch(openModal("verifyEmail"));
    }
  }, [user, modalType, dispatch]);

  useEffect(() => {
    i18n.changeLanguage(storedLang);
    document.documentElement.dir = storedLang === "ar" ? "rtl" : "ltr";
  }, [i18n, storedLang]);

  const location = useLocation();
  const isGameResult = location.pathname.includes("/result");
  const shouldShowAchievementNotification =
    Boolean(user?.new_achievement_earned) && location.pathname !== "/my-achievements";

  return (
    <>
      <GlobalModal />
      {/* <main className="flex h-screen bg-bg-secondary overflow-hidden">
        <section className="flex-1 flex flex-col h-full overflow-hidden">
          <div className="overflow-auto bg-[#F7F7F7] h-full sidebar-scroll"> */}
      <MainHeader />
      <Outlet />
      <NewAchievementNotification visible={shouldShowAchievementNotification} />
      {!isGameResult && <Footer />}
      {/* </div>
        </section>
      </main> */}
      {/* {!isLoading && isSuccess ? (
        <main className="flex h-screen bg-bg-secondary overflow-hidden">
        <section className="flex-1 flex flex-col h-full overflow-hidden">
          <div className="overflow-auto bg-[#F7F7F7] h-full sidebar-scroll">
            <MainHeader />
            <Outlet />
          </div>
        </section>
      </main>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <Loader />
        </div>
      )} */}
    </>
  );
};

export default Main;
